import { Skeleton } from '@/ui'

export const CubkCardCollapsedSkeleton = () => (
  <div
    className="flex flex-col gap-4"
    data-testid="cubk-card-collapsed-skeleton"
  >
    <div className="lg:hidden">
      <Skeleton className="h-6 w-32 rounded-full" />
    </div>
    <div className="flex items-center gap-4">
      <Skeleton className="hidden lg:block h-20 w-20 rounded-md shrink-0" />
      <div className="flex-1 min-w-0 flex flex-col gap-2">
        <Skeleton className="h-7 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <div className="hidden lg:flex">
          <Skeleton className="h-6 w-32 rounded-full" />
        </div>
        <Skeleton className="h-9 w-9 rounded shrink-0" />
      </div>
    </div>
  </div>
)

export const CubkProgressPanelSkeleton = () => (
  <div
    className="flex flex-col gap-6 p-6"
    data-testid="cubk-progress-panel-skeleton"
  >
    <Skeleton className="h-4 w-40" />
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Skeleton className="h-2 flex-1 rounded-full" />
        <Skeleton className="h-4 w-10 shrink-0" />
      </div>
      <Skeleton className="h-3 w-48" />
    </div>
    <Skeleton className="h-px w-full" />
    <div className="grid grid-cols-2 gap-x-4 gap-y-6">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex flex-col gap-1">
          <Skeleton className="h-6 w-20" />
          <Skeleton className="h-3 w-32" />
        </div>
      ))}
    </div>
  </div>
)

const TIMELINE_SKELETON_STEP_COUNT = 5

export const VisualTimelineSkeleton = () => (
  <div className="flex flex-col gap-4" data-testid="cubk-timeline-skeleton">
    {Array.from({ length: TIMELINE_SKELETON_STEP_COUNT }).map((_, i) => (
      <div key={i} className="flex items-center gap-3">
        <Skeleton className="h-6 w-6 rounded-full shrink-0" />
        <Skeleton className="h-4 flex-1" />
      </div>
    ))}
  </div>
)
